import React, { useEffect, useRef } from "react";
import styles from "../styles/Header.module.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Header() {
  const headerRef = useRef(null);

  useEffect(() => {
    const tween = gsap.to(headerRef.current, {
      height: 100,
      duration: 0.8,
      ease: "bounce",
      paused: true,
    });

    ScrollTrigger.create({
      start: 100, // 10px down the page
      onEnter: () => tween.play(),
      onLeaveBack: () => tween.reverse(),
    });

    return () => ScrollTrigger.killAll();
  }, []);

  const scrollToForm = () => {
    const element = document.getElementById("payslip-form");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header ref={headerRef} className={styles.header}>
      <div className={styles.container}>
        <a href="#home" className={styles.logo}>
          Payslip<span className={styles.logoAccent}>Cy</span>
        </a>

        <div className={styles.actions}>
          <a
            href="/"
            className={styles.learnMoreBtn}
          >
            Home
          </a>

          <a onClick={scrollToForm} className={styles.ctaBtn}>
            Get Started
          </a>
        </div>
      </div>
    </header>
  );
}